import { render, staticRenderFns } from "./GlobalCardConfirmationModal.vue?vue&type=template&id=bdc2d9e8"
import script from "./GlobalCardConfirmationModal.vue?vue&type=script&lang=js"
export * from "./GlobalCardConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports